import { defineMessage } from "react-intl"

export const faqsLabelMessage = defineMessage({
  defaultMessage: "FAQs",
  description:
    "Navigation bar label to route users to the Frequently Asked Questions page. Please do not translate the letters F-A-Q-S literally. Use the standard shorthand or acronym for 'Frequently Asked Questions' for the locale (e.g. the equivalent abbreviation that is used)."
})
